<div class="drag-zone" [ngClass]="{ active: isDragOverElement }"></div>
